import { Select, SelectProps, Text } from 'grommet';
import { Yoga } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { TalonTip } from '../TalonTip';
import { SessionActivityType } from '@talon/web/lib/api';

export interface IActivityTypeSelectProps extends SelectProps {
  onChange: (val: SessionActivityType) => void;
  options: SessionActivityType[];
  val?: SessionActivityType;
}

export const ActivityTypeSelect = observer(
  ({
    options,
    val,
    onChange,
    id = 'session-activity-type',
    name = 'session-activity-type',
    ...selectProps
  }: IActivityTypeSelectProps) => {
    /** State **/
    const [filteredOptions, setFilteredOptions] = useState<SessionActivityType[]>(options);

    /** Methods **/
    const filterTypes = (query: string) => {
      if (query === '') {
        setFilteredOptions(options);
        return;
      }
      const exp = new RegExp(query.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
      const filtered = options.filter((t) => exp.test(t));
      setFilteredOptions(filtered);
    };

    useEffect(() => {
      setFilteredOptions(options);
    }, [options]);

    /** Render **/
    return (
      <Select
        value={val}
        size="xsmall"
        icon={
          <TalonTip content={<Text>Choose Activity Type</Text>}>
            <Yoga />
          </TalonTip>
        }
        placeholder="Choose activity type..."
        searchPlaceholder="Search types..."
        onSearch={(query) => filterTypes(query)}
        onChange={({ value }) => onChange(value)}
        onBlur={() => setFilteredOptions(options)}
        {...selectProps}
        id={id}
        name={name}
        options={filteredOptions}
      />
    );
  }
);
